import { api } from "../httpClient";
import { API_ENDPOINTS } from "../config";

export const getRentalConditions = async (searchId, offerHash) => {
  const res = await api.get(API_ENDPOINTS.RENTAL_CONDITIONS, {
    params: { searchId: searchId, offerHash: offerHash },
  });

  return res;
};

// Used on voucher page — fetches by reservationNumber
export const getVoucherRentalConditions = async (reservationNumber) => {
  const res = await api.get(API_ENDPOINTS.RENTAL_CONDITIONS_RESERVATION, {
    params: { reservationNumber },
  });
 
  return res;
};

export const getCancellationPolicy = async (searchId, carOfferHash) => {
  const res = await api.get(API_ENDPOINTS.CANCELLATION_POLICIES, {
    params: { searchId, carOfferHash },
  });
 
  return res;
};